module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};



//////////////////
// WEBPACK FOOTER
// /~/babel-polyfill/~/core-js/modules/_fails.js
// module id = 15
// module chunks = 31